import { SalesOrderAccounting } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1390. 受注案件管理会計一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_accountings
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};

const salesOrderAccountings = (props: Props): Promise<SalesOrderAccounting[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/sales_order_accountings`);
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'sales_order_accountings'];
};

export const useSalesOrderAccountings = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrderAccountings(props)
  });
};

export const useSalesOrderAccountingsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};